import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { oneOnOneColumnsViewEmpty } from "@img/illustrations";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import { greys, time } from "@clockwise/web-commons/src/styles/color.styles";

export const noOneOnOnesImg: CSSProperties = {
  width: 580,
  minWidth: 460,
  height: "65vh",
  backgroundImage: `url(${oneOnOneColumnsViewEmpty})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "contain",
  marginTop: 25,
  "@media (max-width: 610px)": {
    minWidth: "unset !important",
  },
};

export const navButtons: CSSProperties = {
  display: "flex",
  "@media (max-width: 610px)": {
    visibility: "hidden",
  },
};

export const fullView: CSSProperties = {
  display: "flex",
  "@media (max-width: 610px)": {
    flexWrap: "wrap",
    justifyContent: "center !important",
    alignContent: "flex-start",
  },
  marginLeft: "auto",
  marginRight: "auto",
  paddingLeft: 16,
  paddingRight: 10,
  justifyContent: "left",
  overflow: "auto",
  height: "calc(100vh - 70px)",
};

export const columnHeader: CSSProperties = {
  fontSize: 17,
  marginLeft: 10,
  "@media (max-width: 610px)": {
    marginTop: 12,
  },
};

export const columnHeaderSecond: CSSProperties = {
  fontSize: 17,
  marginLeft: 10,
  marginTop: 22,
};

export const allColumns: CSSProperties = {
  display: "flex",
  "@media (max-width: 610px)": {
    flexDirection: "column",
    paddingRight: "0px !important",
    paddingBottom: 10,
  },
  paddingTop: 15,
  paddingRight: 15,
  marginTop: 24,
  alignItems: "flex-start",
};

export const column: CSSProperties = {
  display: "flex",
};

export const columnDivider: CSSProperties = {
  margin: 0,
  borderStyle: "solid",
  width: 1,
  height: "auto",
  borderWidth: 0,
  borderTopWidth: 1,
  marginLeft: 7,
  marginRight: 7,
  borderColor: greys.borderGrey,
  "@media (max-width: 610px)": {
    display: "none",
  },
};

export const eventContainer: CSSProperties = {
  margin: 10,
  backgroundColor: "white",
  borderRadius: 10,
  maxWidth: 345,
  "@media (max-width: 610px)": {
    maxWidth: "580 !important",
  },
  minWidth: 200,
};

export const leftSectionFadeIn: CSSProperties = {
  width: 350,
  minWidth: 270,
  opacity: 1,
  transition: "opacity 0.3s ease-in",
};

export const leftSectionBeGone: CSSProperties = {
  width: 350,
  minWidth: 270,
  opacity: 0,
};

export const toggleOption: CSSProperties = {
  border: `2.48349px solid ${greys.paleGrey}`,
  borderRadius: 10,
  background: "white",
  marginTop: 15,
  padding: 8,
};

export const toggleOptionSelected = Object.assign({}, toggleOption, {
  border: `2.48349px solid ${time.focus}`,
});

export const radioMainText: CSSProperties = {
  fontSize: 14,
  color: greys.dark,
};

export const radioSubtext: CSSProperties = {
  fontSize: 12,
  color: greys.slate,
};

export const subheader: CSSProperties = {
  lineHeight: 1.5,
  color: greys.slate,
  fontSize: 14,
  fontFamily: fontFamilySans,
};

export const whatHappens: CSSProperties = {
  fontSize: 13,
  lineHeight: 1.5,
  fontFamily: fontFamilySans,
};

export const toggleRadios: CSSProperties = {
  marginLeft: 10,
  marginTop: 5,
};

//////////////////////
// Renderer styles
//////////////////////

export const styles = {
  columnHeader,
  columnHeaderSecond,
  allColumns,
  columnDivider,
  column,
  eventContainer,
  fullView,
  toggleOption,
  toggleOptionSelected,
  leftSectionFadeIn,
  leftSectionBeGone,
  subheader,
  whatHappens,
  toggleRadios,
  radioSubtext,
  radioMainText,
  noOneOnOnesImg,
  navButtons,
};
